// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { AddonsOperations } from "./addons/index.js";
export { AuthorizationsOperations } from "./authorizations/index.js";
export { CloudLinksOperations } from "./cloudLinks/index.js";
export { ClustersOperations } from "./clusters/index.js";
export { DatastoresOperations } from "./datastores/index.js";
export { GlobalReachConnectionsOperations } from "./globalReachConnections/index.js";
export { HcxEnterpriseSitesOperations } from "./hcxEnterpriseSites/index.js";
export { HostsOperations } from "./hosts/index.js";
export { IscsiPathsOperations } from "./iscsiPaths/index.js";
export { LicensesOperations } from "./licenses/index.js";
export { LocationsOperations } from "./locations/index.js";
export { MaintenancesOperations } from "./maintenances/index.js";
export { OperationsOperations } from "./operations/index.js";
export { PlacementPoliciesOperations } from "./placementPolicies/index.js";
export { PrivateCloudsOperations } from "./privateClouds/index.js";
export { ProvisionedNetworksOperations } from "./provisionedNetworks/index.js";
export { PureStoragePoliciesOperations } from "./pureStoragePolicies/index.js";
export { ScriptCmdletsOperations } from "./scriptCmdlets/index.js";
export { ScriptExecutionsOperations } from "./scriptExecutions/index.js";
export { ScriptPackagesOperations } from "./scriptPackages/index.js";
export { SkusOperations } from "./skus/index.js";
export { VirtualMachinesOperations } from "./virtualMachines/index.js";
export { WorkloadNetworksOperations } from "./workloadNetworks/index.js";
